import type { ContractRenderData, FieldMeta } from './types';

/**
 * 未选中记录时的示例数据：没有任何真实值，渲染器据此把字段位置画成
 * 〔字段名〕占位。让"加了区块却什么都看不见"的空窗期消失。
 */
export function buildSampleContractData(mainFieldMetas: FieldMeta[]): ContractRenderData {
  return {
    mainRecord: {},
    mainFieldMetas,
    linkedRecords: {},
    attachments: {},
    codes: {},
    sampleMode: true,
  };
}
